module.exports = __webpack_public_path__ + "img/Rotate.1dd6bb6f.svg";